import { type UseControllerProps, type FieldValues, useController } from 'react-hook-form';

import { type CheckboxProps, Checkbox } from '../Checkbox';

type FormCheckboxProps<TFieldValues extends FieldValues> = UseControllerProps<TFieldValues> &
  Omit<CheckboxProps, 'required'>;

function FormCheckbox<TFieldValues extends FieldValues = FieldValues>(
  props: FormCheckboxProps<TFieldValues>,
) {
  const {
    field,
    fieldState: { isTouched },
  } = useController({ ...props, name: props.name });

  return (
    <Checkbox
      {...props}
      {...field}
      onChange={props.onChange ?? field.onChange}
      required={!!(isTouched && props.rules?.required)}
    />
  );
}

export type { FormCheckboxProps };
export { FormCheckbox };
